import { render } from "./GrupoCreate.vue?vue&type=template&id=3c74d034&scoped=true"
import script from "./GrupoCreate.vue?vue&type=script&lang=js"
export * from "./GrupoCreate.vue?vue&type=script&lang=js"

import "./GrupoCreate.vue?vue&type=style&index=0&id=3c74d034&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c74d034"]])

export default __exports__